export class AccountSummary {
    constructor() {
        this.dtrAccSumm = new DebtorAccountSummary();
    }

    dtrAccSumm: DebtorAccountSummary;
}

export class DebtorAccountSummary {
    constructor() {
        this.dtrRefId = '';
        this.lastName = '';
        this.firstName = '';
        this.address = '';
        this.dateOfBirth = '';
        this.phoneNumbers = '';
        this.emailAddress = '';
        this.bankName = '';
        this.totalOutstanding = 0;
        this.currency = '';
        this.accounts = [];
    }

    dtrRefId: string;
    lastName: string;
    firstName: string;
    address: string;
    dateOfBirth: string;
    phoneNumbers: string;
    emailAddress: string;
    bankName: string;
    totalOutstanding: number;
    currency: string;
    accounts: Array<DebtorAccount>;
}

export class DebtorAccount {
    constructor() {
        this.accountId = '';
        this.aggFileCode = '';
        this.clientId = '';
        this.portfolioId = '';
        this.portfolioDesc = '';
        this.clientRef1 = '';
        this.clientRef2 = '';
        this.statusCode = '';
        this.statusDesc = '';
        this.dateOfDebt = '';
        this.currency = '';
        this.totalPaid = 0;
        this.totalOutstanding = 0;
        this.payPlanId = '';
        this.notes = '';
        this.priority = 1;
    }

    accountId: string;
    aggFileCode: string;
    clientId: string;
    portfolioId: string;
    portfolioDesc: string;
    clientRef1: string;
    clientRef2: string;
    statusCode: string;
    statusDesc: string;
    dateOfDebt: string;
    currency: string;
    totalPaid: number;
    totalOutstanding: number;
    payPlanId: string;
    notes: string;
    priority: number;
}

export class DebtSummary {
    constructor() {
        this.debtorId = 0;
        this.totalOutstanding = 0;
        this.accounts = [];
    }

    debtorId: number;
    totalOutstanding: number;
    accounts: Array<DebtAccountSummary>;
}

export class DebtAccountSummary {
    constructor() {
        this.accountId = '';
        this.totalOutstanding = 0;
        this.status = '';
        this.clientName = '';
    }

    accountId: string;
    totalOutstanding: number;
    status: string;
    clientName: string;
}